import extend from 'extend';
import Quill from 'quill';

import MtPicker from '../ui/picker';
import MtColorPicker from '../ui/color-picker';
import MtIconPicker from '../ui/icon-picker';

const ALIGNS = [false, 'center', 'right', 'justify'];

const COLORS = [
  '#000000', '#e60000', '#ff9900', '#ffff00', '#008a00', '#0066cc', '#9933ff',
  '#ffffff', '#facccc', '#ffebcc', '#ffffcc', '#cce8cc', '#cce0f5', '#ebd6ff',
  '#bbbbbb', '#f06666', '#ffc266', '#ffff66', '#66b966', '#66a3e0', '#c285ff',
  '#888888', '#a10000', '#b26b00', '#b2b200', '#006100', '#0047b2', '#6b24b2',
  '#444444', '#5c0000', '#663d00', '#666600', '#003700', '#002966', '#3d1466'
];

const FONTS = [false, 'serif', 'monospace'];

const HEADERS = ['1', '2', '3', false];

const SIZES = ['12px', '14px', '16px', '18px', '20px', '22px', '24px'];
const DEFAULTSIZE = '14px';

const LABELS = {
  size: '字号',
  bold: '加粗',
  underline: '下划线',
  strike: '中划线',
  color: '文本颜色',
  background: '文本高亮',
  list: {
    ordered: '有序列表',
    bullet: '无序列表',
  },
  image: '上传图片',
  mathlive: '公式',
};

const SnowTheme = Quill.import('themes/snow');

class MtSnowTheme extends SnowTheme {
  buildButtons(buttons, icons) {
    super.buildButtons(buttons, icons);
    buttons.forEach((button) => {
      button.classList.add('ql-bar');
    });
  }

  buildPickers(selects, icons) {
    this.pickers = selects.map((select) => {
      if (select.classList.contains('ql-align')) {
        if (select.querySelector('option') == null) {
          fillSelect(select, ALIGNS);
        }
        return new MtIconPicker(select, icons.align);
      } else if (
        select.classList.contains('ql-background') ||
        select.classList.contains('ql-color')
      ) {
        let format = select.classList.contains('ql-background') ? 'background' : 'color';
        if (select.querySelector('option') == null) {
          fillSelect(select, COLORS, format === 'background' ? '#ffffff' : '#000000');
        }
        return new MtColorPicker(select, icons[format]);
      } else {
        if (select.querySelector('option') == null) {
          if (select.classList.contains('ql-font')) {
            fillSelect(select, FONTS);
          } else if (select.classList.contains('ql-header')) {
            fillSelect(select, HEADERS);
          } else if (select.classList.contains('ql-size')) {
            fillSelect(select, SIZES, DEFAULTSIZE);
          }
        }
        return new MtPicker(select);
      }
    });
    let update = () => {
      this.pickers.forEach(function (picker) {
        picker.update();
      });
    };
    this.quill.on(Quill.events.EDITOR_CHANGE, update);
  }

  addLabeltooltip(controls) {
    controls.forEach((control) => {
      let className = control.getAttribute('class') || '';
      className.split(/\s+/).forEach((name) => {
        if (!name.startsWith('ql-')) return;
        name = name.slice('ql-'.length);
        let labeltooltip = '';
        if ('list' === name) {
          const value = control.getAttribute('value');
          labeltooltip = LABELS.list[value];
        } else {
          labeltooltip = LABELS[name];
        }
        if (labeltooltip) {
          control.setAttribute('labeltooltip', labeltooltip);
        }
      });
    });
  }

  extendToolbar(toolbar) {
    super.extendToolbar(toolbar);
    this.addLabeltooltip([].slice.call(toolbar.container.querySelectorAll('.ql-bar')));
  }
}
MtSnowTheme.DEFAULTS = extend(true, {}, SnowTheme.DEFAULTS, {});

function fillSelect(select, values, defaultValue = false) {
  values.forEach(function (value) {
    let option = document.createElement('option');
    if (value === defaultValue) {
      option.setAttribute('selected', 'selected');
    } else {
      option.setAttribute('value', value);
    }
    select.appendChild(option);
  });
}

export default MtSnowTheme;
